export default __webpack_public_path__ + "static/media/mask-webcam.4b7c87de.png";